import React from 'react';
import { Link } from 'react-router-dom';

const StudentInfo = ({ student }) => {
  // Build a full name from first_name and last_name if 'name' isn't provided.
  const fullName = student?.name
    ? student.name
    : `${student?.first_name || ''} ${student?.last_name || ''}`.trim() || 'No Name';

  // Use student.student_id (underscore) instead of student.studentId.
  const studentId = student?.student_id || 'N/A';

  // For initials, use the first character of the fullName if available.
  const initial = fullName ? fullName.charAt(0).toUpperCase() : '?';

  // Fallback in case student is undefined.
  const fallbackStudent = {
    name: 'No Name',
    student_id: 'N/A',
    grade: 'N/A',
    attendancePercentage: 0,
  };
  const displayStudent = student || fallbackStudent;

  return (
    <div className="bg-white rounded-[2rem] shadow-sm overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-indigo-900/5 h-fit border border-slate-100">
      <div className="bg-[#18216D]/5 p-8 border-b border-slate-100">
        <div className="flex items-center space-x-5">
          <div className="h-20 w-20 rounded-2xl bg-[#18216D] flex items-center justify-center transform transition-all hover:scale-105 shadow-lg shadow-indigo-900/20">
            <span className="text-3xl text-white font-black">{initial}</span>
          </div>
          <div>
            <h2 className="text-2xl font-black text-[#18216D] tracking-tight">{fullName}</h2>
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">
              <i className="fas fa-id-card mr-2 text-[#FFC425]" aria-hidden="true"></i>
              Scholar ID: {studentId}
            </p>
          </div>
        </div>
      </div>

      <div className="p-6 space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <h3 className="text-sm font-medium text-gray-500 mb-2 flex items-center">
              <i className="fas fa-graduation-cap mr-2" aria-hidden="true"></i>
              Grade Level
            </h3>
            <p className="text-lg font-semibold text-gray-800">{displayStudent.grade_level_name || 'N/A'}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500 mb-2 flex items-center">
              <i className="fas fa-stream mr-2" aria-hidden="true"></i>
              Stream
            </h3>
            <p className="text-lg font-semibold text-gray-800">{displayStudent.stream_name || 'N/A'}</p>
          </div>
          {displayStudent.career_pathway && (
            <div className="col-span-2">
              <h3 className="text-sm font-medium text-gray-500 mb-2 flex items-center">
                <i className="fas fa-compass mr-2 text-[#FFC425]" aria-hidden="true"></i>
                Career Pathway
              </h3>
              <p className="text-lg font-black text-[#18216D] uppercase tracking-tight">
                {displayStudent.career_pathway.replace('_', ' ')}
              </p>
            </div>
          )}
        </div>

        <div className="border-t border-slate-50 pt-8">
          <div className="grid grid-cols-1 gap-3">
            <button
              className="flex items-center justify-center px-6 py-3 bg-[#18216D] rounded-xl shadow-lg shadow-indigo-900/20 text-[10px] font-black uppercase tracking-widest text-white hover:bg-[#0D164F] transition-all"
              aria-label="View Full Profile"
            >
              <i className="fas fa-id-badge mr-2" aria-hidden="true"></i>
              View Full Profile
            </button>
            <div className="grid grid-cols-2 gap-3">
              <Link
                to="/courses"
                className="flex items-center justify-center px-4 py-3 border-2 border-slate-100 rounded-xl text-[10px] font-black uppercase tracking-widest text-[#18216D] bg-white hover:bg-slate-50 transition-all"
                aria-label="View Learning Areas"
              >
                <i className="fas fa-book mr-2" aria-hidden="true"></i>
                Learning Areas
              </Link>
              <Link
                to="/tasks"
                className="flex items-center justify-center px-4 py-3 border-2 border-slate-100 rounded-xl text-[10px] font-black uppercase tracking-widest text-[#18216D] bg-white hover:bg-slate-50 transition-all"
                aria-label="View Assessments"
              >
                <i className="fas fa-tasks mr-2" aria-hidden="true"></i>
                Assessments
              </Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default StudentInfo;
